import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState } from "react";
import { LeadPlatform, VfModal } from "@vfit/shared/components";
import { checkWindow } from "@vfit/shared/data-access";
export var ModalLeadWrapper = function() {
    var initialLead = {
        title: "",
        onClose: function() {}
    };
    var setModalHeight = function() {
        var defaultValue = 563;
        if (!checkWindow()) return defaultValue;
        var height = window === null || window === void 0 ? void 0 : window.innerHeight;
        if (!height) return defaultValue;
        return height - height * 30 / 100;
    };
    var ref = useState(false), showModal = ref[0], setShowModal = ref[1];
    var ref1 = useState(initialLead), modalDetail = ref1[0], setModalDetail = ref1[1];
    if (typeof document !== "undefined") {
        document.addEventListener("leadModalNotificationEvent", function(event) {
            var detail = event.detail;
            setModalDetail(detail || modalDetail);
            setShowModal(!showModal);
        });
    }
    var resetModalStatus = function() {
        setModalDetail(initialLead);
        setShowModal(false);
    };
    var handleCloseModal = function() {
        if (modalDetail.onClose) modalDetail.onClose();
        resetModalStatus();
    };
    return /*#__PURE__*/ _jsx(VfModal, {
        wrapperId: modalDetail.id,
        height: setModalHeight(),
        isOpen: showModal,
        handleClose: handleCloseModal,
        children: /*#__PURE__*/ _jsx(LeadPlatform, {
            form: modalDetail.form,
            onSuccess: modalDetail.onSuccess,
            onError: modalDetail.onError
        })
    });
};
